import { colors } from '@lmc/common/constants'
import PropTypes from 'prop-types'
import React from 'react'
import { hexToRgbA } from '../../../../../common/utils'
import { ListItem, ProfileBadge } from '../../../../../components/generic'

const MedListLabel = ({ medication }) => {
  if (!medication) return null

  const { controlledDrug, deleted, PRN } = medication

  const labelText = medication.name

  return (
    <div style={styles.medListLabel}>
      {labelText}
      {!deleted && controlledDrug && (
        <ProfileBadge
          backgroundColor={hexToRgbA(colors.red, 0.2)}
          badgeStyle={styles.badge}
          badgeText="CD"
          textColor={colors.red}
        />
      )}
      {!deleted && PRN && (
        <div>
          <ProfileBadge
            backgroundColor={hexToRgbA(colors.blue, 0.2)}
            badgeStyle={styles.badge}
            badgeText="PRN"
            textColor={colors.blue}
          />
        </div>
      )}
      {deleted && (
        <div>
          <ProfileBadge
            backgroundColor={hexToRgbA(colors.darkgrey, 0.2)}
            badgeStyle={styles.badge}
            badgeText="Discontinued"
            textColor={colors.darkgrey}
          />
        </div>
      )}
    </div>
  )
}

export default function MedicationListItem(props) {
  const { medication } = props

  const itemStyle = {
    ...styles.medListItem,
    ...(medication.deleted && { color: colors.grey })
  }

  return (
    <ListItem
      key={medication.id}
      label={<MedListLabel medication={medication} />}
      noIcon
      style={itemStyle}
      to={`/residents/${medication.resident}/emar/${medication.id}/chart`}
    />
  )
}

MedicationListItem.propTypes = {
  medication: PropTypes.object.isRequired
}

const styles = {
  badge: {
    fontSize: 12,
    fontWeight: 'bold',
    marginLeft: 8,
    padding: '3px 12px',
    borderRadius: 15
  },
  medListItem: {
    marginBottom: 16,
    padding: '13px 3px',
    breakInside: 'avoid' // PDF printing
  },
  medListLabel: {
    display: 'flex'
  }
}
